const styles = {
  chipContainer: {
    display: 'flex',
    overflowX: 'auto',
    gap: 2,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
    mx: '-24px',
    px: '24px',
  },
  chip: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  card: {
    height: '65vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  gridContainer: {
    height: '90%',
  },
  fadeOut: {
    transition: 'opacity 0.2s ease-in-out',
    opacity: 0,
  },
  fadeIn: {
    transition: 'opacity 0.2s ease-in-out',
    opacity: 1,
  },
  chipTable: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    flex: 1,
    '& .MuiChip-label': { flex: 1 },
  },
};

export default styles;
